import React, { useState, useEffect, useMemo } from 'react';
import LS from '../../styles/layoutStyled';
import CS from '../../styles/componentStyled';
import styled from 'styled-components';
import InputModal from '../InputModal';
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import {
  blankDefaultMsgRecoil,
  errorMsgRecoil,
  confirmMsgRecoil,
  monthUnitPriceModifyStateRecoil,
} from '../../atom/ModalAtom';
import { roomAPI } from '../../api/axiosIndex';
import { Icon } from '../../component/Icon';

interface MonthUnitPriceModiFyProps {
  onListUpdate: () => void;
}

const MonthUnitPriceModiFy = ({ onListUpdate }: MonthUnitPriceModiFyProps) => {
  const blankMsg = useRecoilValue(blankDefaultMsgRecoil);
  const setError = useSetRecoilState(errorMsgRecoil);
  const setConfirm = useSetRecoilState(confirmMsgRecoil);

  const setModalState = useSetRecoilState(monthUnitPriceModifyStateRecoil);

  const [selectDate, setSelectDate] = useState<string>('');
  const [unitLateId, setUnitLateId] = useState<number>(0);
  const [unitRate, setUnitRate] = useState<number>(0);
  const [modifyUnitRate, setModifyUnitRate] = useState<number | null>(null);
  const [unitRateNone, setUnitRateNone] = useState<boolean>(false);

  const getMonthUnitPrice = async (date: string) => {
    try {
      const response = await roomAPI.getMonthUnitPrice(
        Number(date.split('-')[0]),
        Number(date.split('-')[1]),
      );
      setUnitLateId(response.data.id);
      setUnitRate(response.data.unitRate);
    } catch (err: any) {
      setError('선택하신 날짜는 존재하지 않습니다.');
      setUnitRateNone(true);
      setUnitRate(0);
    }
  };

  const onChangeModifyDate = async (e: React.ChangeEvent<HTMLInputElement>) => {
    setUnitRateNone(false);
    setSelectDate(e.target.value);
    getMonthUnitPrice(e.target.value);
  };

  const handleConfirm = async () => {
    if (unitRateNone) {
      setError('선택하신 날짜는 존재하지 않습니다.');
      return;
    }

    if (modifyUnitRate === null) {
      setError(blankMsg);
      return;
    }

    try {
      await roomAPI.putMonthUnitPrice(unitLateId, modifyUnitRate);
      setModalState(false);
      onListUpdate();
      setConfirm('성공적으로 수정되었습니다.');
    } catch {
      setError('단가 수정에 실패했습니다.');
    }
  };

  useEffect(() => {
    const today = new Date();
    const formattedDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}`;
    setSelectDate(formattedDate);
    getMonthUnitPrice(formattedDate);
  }, []);

  return (
    <>
      <InputModal
        title="단가 수정"
        onCancel={() => setModalState(false)}
        onConfirm={handleConfirm}
      >
        <ul className="input-wrap">
          <li>
            <h2>수정 날짜</h2>
            <CS.TextInputType1
              type="month"
              value={selectDate}
              onChange={onChangeModifyDate}
            />
          </li>
          <li>
            <h2>현재 단가</h2>
            <CS.TextInputType1
              placeholder="0"
              type="text"
              disabled={true}
              value={unitRate.toLocaleString()}
              onChange={(e) => setUnitRate(e.target.valueAsNumber)}
            />
          </li>
          <li>
            <h2>
              수정 단가
              <span className="img-box">
                <Icon name="StarIcon" size="100%" color="#FF5151" />
              </span>
            </h2>
            <CS.TextInputType1
              placeholder="수정 단가 입력"
              type="text"
              value={
                modifyUnitRate !== null ? modifyUnitRate.toLocaleString() : ''
              }
              disabled={unitRateNone}
              onChange={(e) => {
                const value = e.target.value
                  .replace(/[^0-9]/g, '')
                  .replace(/,/g, '');
                setModifyUnitRate(value === '' ? null : Number(value));
              }}
            />
          </li>
        </ul>
      </InputModal>
    </>
  );
};

export default MonthUnitPriceModiFy;
